import MainLayout from '@/common/components/layouts/MainLayout';
import AmountDamageCard from '@/modules/adjusterReportModules/IncidentParticipants/components/expert/AmountDamageCard';
import ExpertEntryTabs from '@/modules/adjusterReportModules/IncidentParticipants/components/expert/EntryTabs';
import { Box } from 'styled-system/jsx';

export default () => {
  return (
    <MainLayout title="زیان‌دیده / کارشناسی" header="titleHeader">
      <Expert />
    </MainLayout>
  );
};
const Expert = () => {
  return (
    <Box pt={24}>
      <AmountDamageCard />
      <ExpertEntryTabs />
    </Box>
  );
};
